<template src="./Index.html">
</template>

<script>


    export default {
        components: {

        },
        created() {
            this.getAll();
          this.$store.dispatch("lookups/getLookups");
                this.$store.dispatch("lookups/getSpecialties")

        },
        computed: {

            types() {
                return this.$store.getters["lookups/getLookupByType"](this.$lookupTypes.CourseTypes)
            },
            info() {
                return this.$store.state.courses.courses;
            },
            pageCount() {
                return Math.ceil(
                    this.$store.state.courses.totalItems / this.filters.pageSize
                );
            },
              specialties() {
                return this.$store.state.lookups.specialties;

            },
        },
        data() {
            return {

                dialog: false,
                dialogMessage: null,
                dialogMessage2: null,



               
              
                headers: [
                    {
                        text: "اسم الدورة",
                        value: "courseName",
                        sortable: false,
                        align: "start",
                    },
                    {
                        text: "التخصص",
                        value: "specialty",
                        sortable: false,
                        align: "start",
                    },

                    {
                        text: "المتكفل بالدورة",
                        value: "courseType",
                        sortable: false,
                        align: "start",
                    },
                    {
                        text: "تاريخ الدورة",
                        value: "courseDate",
                        sortable: false,
                        align: "start",
                    },
                    {
                        text: "مصدر  الدورة",
                        value: "source",
                        sortable: false,
                        align: "start",
                    },
                      {
                        text: "الإجراءات",
                        value: "actions",
                        sortable: false,
                        align: "center",
                    },
                ],
                items: [
                    {
                        text: "ملف الموظف ",
                    },
                    {
                        text: "دورات الموظف",
                    },
                ],
                totalItems: 0,
                subtitle: "دورات الموظف",



                filters: {
                    page: 1,
                    pageSize: 10,
                    courseTypeId: null,
                    courseName: null,
                    specialtyId:null
                },

            };
        },
        methods: {
            download(id) {
                window.open(`/api/courses/${id}/attachment`, "_blank")
            },
            getAll(page) {
                this.filters.page = page || 1;
                this.$store.dispatch("courses/getCourses", this.filters);
            },

            showDialog(item) {
                this.dialogMessage = item.courseName;
                this.dialogMessage2 = item.source;
                this.dialog = true;
            },

            cancelDialog() {
                this.dialog = false;
                this.dialogMessage = null;
                this.dialogMessage2 = null;
            },
            back() {
                this.view = 0;
                this.items = [
                    {
                        text: "ملف الموظف ",
                    },
                    {
                        text: "دورات الموظف",
                    },
                ];
            },

        },
    };
</script>
